import React from 'react'
import {withToggles, withDialogError} from 'startlibs/lib/hocs'
import {Errors, Form, withForm, TextInput, SimpleRadiobox, Field} from 'startlibs/lib/form'
import {Dialog, Button, SplitColumnsContainer} from 'startlibs/lib/components'
import styled from 'styled-components'

const SavingTemplatesDialog = styled(Dialog)`
  max-width: 50rem;
`
@withDialogError
@withForm()
@withToggles('keepContentMessage')
export class SaveTemplateDialog extends React.Component {

  preValidation = (success) => {
    if (!success.label) {
      return {errors:{label:['Template name is required.']}}
    } else if (!this.props.overwritingTemplate && this.props.availableTemplates.find(t => t.label === success.label)) {
      return {errors:{label: ['Template name already exists.']}}
    } else {
      return {success}
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.isLoading && !newProps.isLoading && !newProps.form.connector.hasErrors()) {
      this.props.closeDialog()
    }
    if (newProps.form.properties.keepContent !== this.props.form.properties.keepContent) {
      newProps.keepContentMessage.open()
    }
  }

  render() {
    const {form, overwritingTemplate, closeDialog, withoutSignatures, keepContentMessage} = this.props
    return <SavingTemplatesDialog
      className="save-template-dialog"
      title={overwritingTemplate ? 'Overwrite ' + overwritingTemplate.label : 'New template'}
      form={form}
      closeDialog={closeDialog}
    >
      <Form form={form} alwaysSave preValidation={this.preValidation} onSuccess={closeDialog} handleSubmit={this.props.save}>
        <Dialog.Content>
          <TextInput
            form={form}
            path="label"
            locked={!!overwritingTemplate}
            disabled={!!overwritingTemplate}
            label="Template name"
          />

          <SplitColumnsContainer>
              <Field label="Save fields' content in the template?">
                <div className="radio-list">
                  <SimpleRadiobox
                    form={form}
                    path="keepContent"
                    fieldValue={true}
                    label="Yes, keep fields, labels and its contents"
                  />
                  <SimpleRadiobox
                    form={form}
                    path="keepContent"
                    fieldValue={false}
                    label="No, keep fields and labels only"
                  />
                </div>
              </Field>
            {
              !withoutSignatures &&
              <Field label="Save signatures in the template?">
                <div className="radio-list">
                  <SimpleRadiobox
                    form={form}
                    path="keepSignatures"
                    fieldValue={true}
                    label="Yes, keep added signatures"
                  />
                  <SimpleRadiobox
                    form={form}
                    path="keepSignatures"
                    fieldValue={false}
                    label="Do not keep added signatures"
                  />
                </div>
              </Field>
            }
          </SplitColumnsContainer>

          {overwritingTemplate && !form.properties.keepContent && keepContentMessage.isOpen &&
          <ul className="infoContainer">
            <li><span>By selecting this option only fields and labels will be overwritten. Field contents will be kept as previously saved on the template.</span><span
              className="icon icon-x" onClick={keepContentMessage.close}/></li>
          </ul>}
          <Errors form={form}/>

        </Dialog.Content>

        <Dialog.Footer>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button highlight isLoading={form.isLoading} type="submit">
            {overwritingTemplate ? 'Overwrite template' : 'Save'}
          </Button>
        </Dialog.Footer>
      </Form>
    </SavingTemplatesDialog>
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/template/SaveTemplateDialog.jsx